import { createContext } from 'react';
import { ResponsiveImageSet } from '@/utils/ResponsiveImage';

interface HoverImage {
  hoverImage: ResponsiveImageSet | null;
  hoverImageAlt?: string;
}

export interface CarouselContextProps {
  centerText?: boolean;
  hoverImages?: HoverImage[];
}

const CarouselContext = createContext<CarouselContextProps>({});

export default CarouselContext;
